import { createSlice } from '@reduxjs/toolkit';

const settingsSlice = createSlice({
  name: 'settings',
  initialState: {
    defaultTenure: 6,
    searchQuery: '',
    filters: {
      priceRange: { min: 0, max: 10000 },
      brands: [],
      inStock: false,
      rating: 0
    },
    location: 'Mumbai'
  },
  reducers: {
    setDefaultTenure(state, action) {
      state.defaultTenure = action.payload;
    },
    setSearchQuery(state, action) {
      state.searchQuery = action.payload;
    },
    setFilters(state, action) {
      state.filters = { ...state.filters, ...action.payload };
    },
    setLocation(state, action) {
      state.location = action.payload;
    },
    resetFilters(state) {
      state.filters = {
        priceRange: { min: 0, max: 10000 },
        brands: [],
        inStock: false,
        rating: 0
      };
    }
  }
});

export const { setDefaultTenure, setSearchQuery, setFilters, setLocation, resetFilters } = settingsSlice.actions;
export default settingsSlice.reducer;
